import { keepPreviousData } from "@tanstack/react-query";
import { type ColumnFiltersState } from "@tanstack/react-table";
import { useGetV4ProductReportTotals } from "./v4ProductReportTotals";

type Params = {
  productId: string | number;
  filters?: ColumnFiltersState;
  search?: string;
  start?: Date;
  end?: Date;
  preStart?: Date;
  preEnd?: Date;
};

type Options = {
  enabled?: boolean;
};

export const useProductTotals = (
  { productId, filters = [], search, ...dates }: Params,
  { enabled = true }: Options = {},
) => {
  const totalsOptionsGetter = useGetV4ProductReportTotals();

  return {
    ...totalsOptionsGetter({
      filters: [
        {
          id: "product_id",
          value: { op: "=", value: productId },
        },
        ...filters,
      ],
      search,
      ...dates,
    }),
    enabled,
    placeholderData: keepPreviousData,
  };
};
